module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/Pages/manage/manage.component.html
// module id = ./src/app/Pages/manage/manage.component.html
// module chunks = main